import React, { useEffect } from 'react'
import { Button } from 'antd';
import tools1 from '../../images/tools-1.png'
import tools2 from '../../images/tools-2.jpg'
import tools3 from '../../images/tools-3.jpg'
import tools4 from '../../images/tools-4.png'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import ToolCard from './ToolCard';


SwiperCore.use([Navigation]);

const swiperParams = {
    slidesPerView: 1.1,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 8.2,
        },
        600: {
            slidesPerView: 4.5,
        },
    },
}

// const { TabPane } = Tabs;

const viewAll = <Button type="primary" >View All</Button>;


function ToolSection() {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="">
                    <div className="p-2 flex justify-between border-b">
                        <h2 className="text-2xl font-bold text-gray-700">Tools</h2>
                        {viewAll}
                    </div>
                    <div className="px-2">
                        <Swiper
                            {...swiperParams}
                            navigation={true}
                            // onSlideChange={() => console.log('slide change')}
                            // onSwiper={(swiper) => console.log(swiper)}
                            >
                            <SwiperSlide key="1">
                                <ToolCard imageUrl={tools1} />
                            </SwiperSlide>

                            <SwiperSlide key="2">
                                <ToolCard imageUrl={tools2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="3">
                                <ToolCard imageUrl={tools3} />
                            </SwiperSlide>

                            <SwiperSlide key="4">
                                <ToolCard imageUrl={tools4} />
                            </SwiperSlide>

                            <SwiperSlide key="5">
                                <ToolCard imageUrl={tools2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="6">
                                <ToolCard imageUrl={tools3} />
                            </SwiperSlide>

                            <SwiperSlide key="7">
                                <ToolCard imageUrl={tools1} />
                            </SwiperSlide>

                            <SwiperSlide key="8">
                                <ToolCard imageUrl={tools2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="9">
                                <ToolCard imageUrl={tools4} />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    
                    
                </div>
            </div>
            
        </div>
    );
}

export default ToolSection;
